import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, CircularProgress, Grid, Paper, TextField } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import { EditCompanyDetails, GetCompany } from '../services/httpServices';

const EditCompany = (props) => {
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);
  const [company, setCompany] = useState({});
  const [vertical, setVertical] = useState('top');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const companyLegalNameRef = useRef('');

  const companyGSTNumberRef = useRef('');

  const fetchCompany = async (event) => {
    const company = await GetCompany(props.id);
    setCompany(company);
    setLoading(false);
  };
  useEffect(() => {
    fetchCompany();
  }, []);
  // #endregion Refs

  //   const handleClose = () => {
  //     setOpen(false);
  //   };

  const SaveUser = async (event) => {
    setLoading(true);
    event.preventDefault();
    //console.log('saveHit');
    const payload = {
      id: props.id,
      companyName: companyLegalNameRef.current.value,
      companyGst: companyGSTNumberRef.current.value,
    };

    //console.log(payload);
    let response = await EditCompanyDetails(payload);
    //console.log('PostResponse:', response);

    if (response.status == 200) {
      setLoading(false);
      props.setMessage('Company has been updated successfully.');
      props.setSaved(true);
      props.setOpen(true);
      let companySaved = company;
      companySaved.companyName = response.data.companyName;
      companySaved.companyGst = response.data.companyGst;
      setCompany(companySaved);
      // setTimeout(() => {
      //   navigate(`/app/EditCompany/${response.data.id}`);
      // }, 2000);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  //console.log('companyLegalNameRef:', companyLegalNameRef.current);
  return (
    <>
      <form onSubmit={SaveUser}>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box component={Paper} p={1}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Company Operating Name"
                      required
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company?.companyName}
                      inputRef={companyLegalNameRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <TextField
                      label="Company G.S.T #"
                      variant="outlined"
                      fullWidth
                      size="small"
                      defaultValue={company?.companyGst}
                      inputRef={companyGSTNumberRef}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    {' '}
                    <TextField
                      label="Branch"
                      variant="outlined"
                      fullWidth
                      disabled
                      size="small"
                      defaultValue={company?.branchName}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <Button type="submit" variant="contained">
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </form>
    </>
  );
};

export default EditCompany;
